module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/insights-sushma-kaushik.json
// module id = 1414
// module chunks = 275273388302904